import { FC } from 'react';

import { UserPopover } from '@bonusly/common-user-popover';
import { Link } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { Bonus } from '../../../../../types/bonus';
import { Route } from '../../config/router';
import { BonusFeedTrackedAction, useTrackBonusFeedItemEvent } from '../../hooks/use-bonus-feed-item-analytics';
import { pathWithId } from '../../utils/api';

interface GiverNameProps {
	bonus: Bonus;
}

export const GiverName: FC<GiverNameProps> = ({ bonus }) => {
	const { initiator, giver, hide_giver } = bonus;
	const recognizeURL = useBuildRecognizeURL();

	const trackGiverClick = useTrackBonusFeedItemEvent(bonus, BonusFeedTrackedAction.GiverClick);

	const trackInitiatorClick = useTrackBonusFeedItemEvent(bonus, BonusFeedTrackedAction.InitiatorClick);

	if ((!giver && !initiator) || hide_giver) {
		return null;
	}

	const onClick = initiator ? trackInitiatorClick : trackGiverClick;
	const user = initiator || giver;

	return (
		<>
			<UserPopover userId={user.id} openDelay={500} placement="top">
				<Link
					color="inherit"
					onClick={(e) => {
						e.stopPropagation();
						onClick();
					}}
					href={recognizeURL(pathWithId(Route.UserProfile, user.id))}
				>
					{user.display_name}
				</Link>
			</UserPopover>
			:
		</>
	);
};
